import React, { Component } from 'react';

export default class TwitterIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M25.15,72.481c30.147,0 46.644,-25 46.644,-46.644c0,-0.703 0,-1.406 -0.032,-2.11c3.197,-2.302 5.978,-5.211 8.184,-8.504c-2.941,1.311 -6.106,2.174 -9.431,2.59c3.389,-2.014 5.978,-5.243 7.225,-9.08c-3.165,1.887 -6.682,3.229 -10.422,3.965c-3.005,-3.197 -7.257,-5.18 -11.957,-5.18c-9.047,0 -16.4,7.354 -16.4,16.401c0,1.279 0.16,2.526 0.415,3.74c-13.619,-0.671 -25.703,-7.225 -33.792,-17.135c-1.406,2.429 -2.206,5.243 -2.206,8.248c0,5.69 2.91,10.71 7.289,13.651c-2.685,-0.096 -5.211,-0.831 -7.417,-2.046c0,0.064 0,0.128 0,0.224c0,7.928 5.659,14.578 13.14,16.08c-1.375,0.384 -2.813,0.576 -4.316,0.576c-1.055,0 -2.078,-0.096 -3.069,-0.288c2.078,6.522 8.152,11.254 15.314,11.381c-5.627,4.412 -12.692,7.034 -20.365,7.034c-1.311,0 -2.622,-0.064 -3.9,-0.224c7.225,4.604 15.857,7.321 25.096,7.321"/>
              </g>
            </svg>
        )
    }
}
